import { Box } from '@material-ui/core'
import styled from 'styled-components'

export const StyledNavLinkInner = styled(Box)<{ iconTextVertAlign?: string }>`
  & {
    display: grid;
    grid-template-rows: 1fr 1fr;
    width: 100%;
    height: 100%;
  }
`
